<template>
	<div class="logout">
	</div>
</template>
<script>
	import moment from 'moment';
	export default {
		name: 'logout',
		components: {
		},
		data:function(){
			return{
			}
		},
		mounted: function(){
			var self = this;
			self.$cookies.remove("username");
			self.$cookies.remove("user_level");
			self.$cookies.remove("uid");
			self.$cookies.remove("auth_token");
			self.$cookies.remove("school_code");
			self.$cookies.remove("school_id");
			self.$cookies.remove("school_enname");
			self.$cookies.remove("school_chname");
			self.$cookies.remove("school_name");
			self.$cookies.remove("school_chi_name");
			self.$cookies.remove("booking_id");
			self.$cookies.remove("experiment");
			self.$cookies.remove("equipment_id");
			self.$cookies.remove("session_token");
			self.$cookies.remove("role");
			self.$cookies.remove("end_at");
			self.$cookies.remove("display_name");

			let username = null;
			let display_name = null;
			let school_code = null;
			let school_id = null;
			let school_enname = null;
			let school_chname = null;
			let user_level = null;
			let logged_in = false;
			let auth_token = null;
			let uid = null;
			sessionStorage.setItem("justLoggedOut", "1");
			self.$store.commit("updateUserInfo", {username, user_level, school_code, school_enname, school_chname, logged_in, auth_token, uid, display_name});
			self.$router.push("/");			
// 			window.location.href = process.env.VUE_APP_BASE_URL;
		},
		methods:{
		}
	}
</script>